import { createSlice } from '@reduxjs/toolkit';
import { LICENSE_INITIAL_STATE } from './license.constants';
import { getLicensesReducer } from './license.reducers';

const licenseSlice = createSlice({
  name: 'license',
  initialState: LICENSE_INITIAL_STATE,
  reducers: {},
  extraReducers: builder => {
    getLicensesReducer(builder);
  },
});

export default licenseSlice.reducer;
